"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(wrapWithCases);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapWithCases = void 0;

var debug_1 = __importDefault(require("debug"));

var debug = debug_1.default("codec:wrap:dispatch");

var Format = __importStar(require("../format"));

var errors_1 = require("./errors");

function wrapWithCases(dataType, input, wrapOptions, cases) {
  var bestError, specificityFloor, _iterator, _step, caseFn;

  return _regeneratorRuntime.wrap(function wrapWithCases$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          specificityFloor = wrapOptions.specificityFloor || 0;
          _iterator = _createForOfIteratorHelper(cases);
          _context.prev = 2;

          _iterator.s();

        case 4:
          if ((_step = _iterator.n()).done) {
            _context.next = 20;
            break;
          }

          caseFn = _step.value;
          _context.prev = 6;
          return _context.delegateYield(caseFn(dataType, input, Object.assign(Object.assign({}, wrapOptions), {
            specificityFloor: 0
          })), "t0", 8);

        case 8:
          return _context.abrupt("return", _context.t0);

        case 11:
          _context.prev = 11;
          _context.t1 = _context["catch"](6);

          if (_context.t1 instanceof errors_1.TypeMismatchError) {
            _context.next = 17;
            break;
          }

          throw _context.t1;

        case 17:
          if (!bestError || _context.t1.specificity > bestError.specificity) {
            bestError = _context.t1;
          }

        case 18:
          _context.next = 4;
          break;

        case 20:
          _context.next = 25;
          break;

        case 22:
          _context.prev = 22;
          _context.t2 = _context["catch"](2);

          _iterator.e(_context.t2);

        case 25:
          _context.prev = 25;

          _iterator.f();

          return _context.finish(25);

        case 28:
          //if we've made it this far, no case has matched
          if (bestError && bestError.specificity < specificityFloor) {
            bestError.specificity = specificityFloor; //mutating this should be fine, right?
          }

          throw bestError || new errors_1.TypeMismatchError( //last-resort error
          dataType, input, wrapOptions.name, specificityFloor, //it doesn't matter, but we'll make this error lowest specificity
          "Input for ".concat(wrapOptions.name, " was not recognizable as type ").concat(Format.Types.typeStringWithoutLocation(dataType)));

        case 30:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2, 22, 25, 28], [6, 11]]);
}

exports.wrapWithCases = wrapWithCases;